import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import Login from './../../components/Auth/Login/Login';
// api call
import { LoginContext } from './../../contexts/constant/ActionTypes';

const LoginPage = ({ history }) => {
	const loginContext = useContext(LoginContext);
	return (
		<Login
			history={history}
			loginContext={loginContext}
		/>
	);
}

LoginPage.propTypes = {
    history: PropTypes.instanceOf(Object)
};

LoginPage.defaultProps = {
    history: {}
};

export default LoginPage;



// WEBPACK FOOTER //
// ./containers/Auth/LoginPage.js